import { useCallback } from 'react';
import { useQueryParamState } from './useQueryParamState';

export const useQueryParamPagination = ({
  defaultLimit = 25,
}: {
  defaultLimit: number;
}) => {
  const [limit, setLimit] = useQueryParamState<string | undefined>(
    'limit',
    undefined,
    defaultLimit.toString(),
  );

  const [offset, setOffset] = useQueryParamState<string | undefined>('offset');

  const setLimitNumber = useCallback(
    (newLimit: number) => {
      setLimit(newLimit.toString());
    },
    [setLimit],
  );

  const setOffsetNumber = useCallback(
    (newOffset: number) => {
      setOffset(newOffset.toString());
    },
    [setOffset],
  );

  const limitNumber = parseInt(limit ?? defaultLimit.toString(), 10);

  const offsetNumber = parseInt(offset ?? '0', 10);

  return {
    limit: limitNumber,
    offset: offsetNumber,
    setLimit: setLimitNumber,
    setOffset: setOffsetNumber,
  };
};
